import { z } from 'zod'
import { MenuDtoSchema } from '~/services/api/generated'

/** A menu's status and weekly hours; re-wrapped as a non-strict object so a full menu payload parses. */
export const EventAvailabilityMenu = z.object(
  MenuDtoSchema.pick({
    availability_mode: true,
    custom_hours: true,
    schedule: true,
    status: true,
    sync_with_store_hours: true
  }).shape
)

export type EventAvailabilityMenu = z.output<typeof EventAvailabilityMenu>
